import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const EpicToaster = ({ theme, ...props }: ToasterProps) => {
	return (
		<Sonner
			theme={theme}
			className="toaster group"
			toastOptions={{
				classNames: {
					toast:
						'group toast group-[.toaster]:bg-white group-[.toaster]:text-zinc-950 group-[.toaster]:border-zinc-950/10 group-[.toaster]:shadow-lg dark:group-[.toaster]:bg-zinc-800 dark:group-[.toaster]:text-white dark:group-[.toaster]:border-white/10',
					description:
						'group-[.toast]:text-zinc-500 dark:group-[.toast]:text-zinc-400',
					actionButton:
						'group-[.toast]:bg-zinc-900 group-[.toast]:text-white dark:group-[.toast]:bg-white dark:group-[.toast]:text-zinc-950',
					cancelButton:
						'group-[.toast]:bg-zinc-100 group-[.toast]:text-zinc-500 dark:group-[.toast]:bg-zinc-700 dark:group-[.toast]:text-zinc-300',
				},
			}}
			{...props}
		/>
	)
}

export { EpicToaster }
